import PropTypes from 'prop-types';

const CompassIcon = ({ className = '' }) => (
  <svg
    width="215"
    height="215"
    viewBox="0 0 215 215"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M199 0H16C7.16344 0 0 7.16344 0 16V199C0 207.837 7.16344 215 16 215H199C207.837 215 215 207.837 215 199V16C215 7.16344 207.837 0 199 0Z"
      fill="#F4EFED"
    />
    <circle cx="107.5" cy="107.501" r="107.5" fill="white" />
    <path
      d="M157.411 57.5879L86.1102 86.1082L57.5898 157.409L128.891 128.889L157.411 57.5879Z"
      fill="#FB6E44"
    />
    <circle cx="107.5" cy="107.501" r="14.5" fill="#0A0777" />
  </svg>
);

CompassIcon.propTypes = {
  className: PropTypes.string
};

export default CompassIcon;
